import { z } from 'zod';
import { IsoInstantSchema, PageQuerySchema } from './common.js';
export const AuditEventSchema = z.object({
    id: z.number().int().positive(),
    entityType: z.string(),
    entityId: z.string(),
    actorId: z.number().int().positive().nullable(),
    actorEmail: z.string().nullable(),
    fromState: z.string().nullable(),
    toState: z.string().nullable(),
    occurredAt: IsoInstantSchema,
    detail: z.string().nullable(),
});
export const AuditListQuerySchema = PageQuerySchema.extend({
    entityId: z.string().max(64).optional(),
    entityType: z.string().max(40).optional(),
    actorId: z.coerce.number().int().positive().optional(),
});
//# sourceMappingURL=audit.dto.js.map